import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowLeft, MapPin, Clock } from "lucide-react";
import SiteNavbar from "@/components/SiteNavbar";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

const STATS = [
  { icon: Star, value: "4.9", label: "average client rating" },
  { icon: MapPin, value: "Surrey-based", label: "UK agency" },
  { icon: Clock, value: "100%", label: "on-time delivery" },
];

export default function About() {
  return (
    <div className="min-h-screen bg-[#0a1f3d] text-white">
      <SiteNavbar />

      <main className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-sm text-white/80">
          <Star className="h-4 w-4 text-[#e9a31e]" />
          About Us
        </div>

        <h1 className="mt-6 text-4xl font-extrabold tracking-tight sm:text-6xl">
          Who We <span className="text-[#e9a31e]">Are</span>
        </h1>

        <div className="mt-6 max-w-3xl space-y-5 text-lg leading-relaxed text-white/75">
          <p>
            Online Office Solutions is a Surrey-based digital agency run by one
            person who handles your account personally from start to finish. No
            account managers, no junior handoffs, no being passed around — just
            straightforward, results-focused work from someone who genuinely
            cares whether your business grows.
          </p>
          <p>
            We specialise in web design, digital marketing, SEO, and lead
            generation for local businesses across Surrey and the South East.
            Whether you are starting from scratch or looking to scale, we build
            you a complete online presence and then grow it — handling
            everything so you can focus on what you do best.
          </p>
          <p>
            Every client goes onto a 12-month growth plan because real results
            take time to build. We are not here for a quick build and goodbye —
            we are here to be your long-term digital partner.
          </p>
        </div>

        <Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          {STATS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-7"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e9a31e]/15 text-[#e9a31e]">
                  <Icon className="h-5 w-5" />
                </div>
                <p className="mt-5 text-3xl font-extrabold text-[#e9a31e]">
                  {s.value}
                </p>
                <p className="mt-1 text-white/60">{s.label}</p>
              </div>
            );
          })}
        </div>
        </Reveal>

        <Reveal>
        <div className="mt-14 flex flex-col items-start gap-5 rounded-2xl border border-white/10 bg-gradient-to-br from-[#0e2647] to-[#0a1f3d] p-8 md:flex-row md:items-center md:justify-between">
          <h3 className="text-2xl font-bold">Want to work with us?</h3>
          <Link
            to="/audit"
            className="w-full shrink-0 rounded-lg bg-[#e9a31e] px-6 py-3.5 text-center text-base font-bold text-[#0a1f3d] transition-colors hover:bg-[#f2b743] md:w-auto"
          >
            Book Your Free Audit
          </Link>
        </div>
        </Reveal>
      </main>

      <Footer />
    </div>
  );
}
